// The two default colours are stored donor-page configuration, not portal chrome.
const DEFAULT_PRIMARY_COLOR = "#1d4ed8";
const DEFAULT_SECONDARY_COLOR = "#6b7280";
export const DEFAULT_FORM_BRANDING = {
    primaryColor: DEFAULT_PRIMARY_COLOR,
    secondaryColor: DEFAULT_SECONDARY_COLOR,
    backgroundColor: null,
    bannerImageUrl: null,
    bannerImagePosition: "Center",
    fontFamily: "System",
    borderRadius: "Medium",
    formPosition: "FullWidth",
};
// CONSTRAINT: two-decimal currencies only. Amounts are authored in whole units × 100, and the opdon
// hand-off refuses any other minor unit (OpdonHttpDonationApi::hasTwoDecimalMinorUnit).
export const FORM_CURRENCY_CODES = ["EUR", "CAD"];
export function initialFormCurrency(workspaceCurrency) {
    return workspaceCurrency !== null && FORM_CURRENCY_CODES.includes(workspaceCurrency)
        ? workspaceCurrency
        : "EUR";
}
export const DEFAULT_FORM_SETTINGS = {
    showAffectationWhenSingleProject: false,
    requirePhone: false,
    consentText: null,
    allowedEmbedOrigins: [],
    legalNoticeText: null,
    minimumAmountMinor: null,
    showNewsletterOptIn: true,
    requireConsent: true,
    enableBirthDate: false,
    allowCompanyDonation: false,
    enableTaxReduction: false,
    taxResidenceCountry: "FR",
    eligibleIFI: false,
    eligibleColuche: false,
};
